import { dao } from '@platform/dao';
import { baseApi, run, statsTag } from '@platform/state/api';
import type { IElsewhereRecords } from './IElsewhereRecords';
import type { IElsewhereRecordsArg } from './IElsewhereRecordsArg';

/** Перший простір-кандидат (по черзі, як find прототипу) з хоча б одним записом типу; жодного — null. */
async function firstWithRecords({ rt, candidates }: IElsewhereRecordsArg): Promise<IElsewhereRecords | null> {
  for (const ws of candidates) {
    const page = await dao.records.list(ws, rt, { pageSize: 10, facets: false });
    if (page.total > 0) return { ws, total: page.total };
  }
  return null;
}

/** Записи типу в інших просторах користувача (прототип v4 baElsewhere: s.workspaces.find(w => w.id !== ws.id && w.records.ba.length)). */
export const elsewhereRecordsApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    elsewhereRecords: b.query<IElsewhereRecords | null, IElsewhereRecordsArg>({
      queryFn: (arg) => run(() => firstWithRecords(arg)),
      providesTags: (_r, _e, { rt }) => [statsTag(rt)],
    }),
  }),
});

export const { useElsewhereRecordsQuery } = elsewhereRecordsApi;
